// Router
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

// Animation
import { motion } from "framer-motion";

// Styles
import styled from "styled-components";
import { primaryColor } from "./GlobalStyle";

const Nav = () => {
  const { pathname } = useLocation();

  return (
    <StyledNav>
      <h1>
        <Link id="logo" to="/">
          Asif Azimi
        </Link>
      </h1>
      <ul>
        <li>
          <LinkWrapper>
            <Link to="/">About</Link>
            <Line
              transition={{ duration: 0.75 }}
              initial={{ width: "0%" }}
              animate={{ width: pathname === "/" ? "120%" : "0" }}
              className={pathname === "/" ? "active" : ""}
            />
          </LinkWrapper>
        </li>
        <li>
          <LinkWrapper>
            <Link to="/work">Projects</Link>
            <Line
              transition={{ duration: 0.75 }}
              initial={{ width: "0%" }}
              animate={{ width: pathname === "/work" ? "120%" : "0%" }}
              className={pathname === "/work" ? "active" : ""}
            />
          </LinkWrapper>
        </li>
        <li>
          <LinkWrapper>
            <Link to="/contact">Contact</Link>
            <Line
              transition={{ duration: 0.75 }}
              initial={{ width: "0%" }}
              animate={{ width: pathname === "/contact" ? "120%" : "0%" }}
              className={pathname === "/contact" ? "active" : ""}
            />
          </LinkWrapper>
        </li>
      </ul>
    </StyledNav>
  );
};

const StyledNav = styled.nav`
  display: flex;
  min-height: 10vh;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 10rem;
  background: #282828;
  position: sticky;
  top: 0;
  z-index: 10;

  a {
    color: #fff;
    text-decoration: none;
  }

  ul {
    display: flex;
    list-style: none;
  }

  #logo {
    font-size: 1.5rem;
    font-family: "Lobster", cursive;
    font-weight: lighter;
  }

  li {
    padding-left: 10rem;
    position: relative;
  }

  @media (max-width: 1300px) {
    padding: 1rem 5rem;

    li {
      padding-left: 5rem;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 1rem 2rem;
    min-height: auto;

    ul {
      margin-top: 1rem;
      flex-wrap: wrap;
      justify-content: center;
    }

    li {
      padding-left: 2rem;
      padding-right: 2rem;
    }

    #logo {
      font-size: 1.3rem;
    }
  }

  @media (max-width: 480px) {
    padding: 1rem;

    ul {
      flex-direction: column;
      text-align: center;
      width: 100%;
    }

    li {
      padding: 0.5rem 0;
    }
  }
`;

const LinkWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const Line = styled(motion.div)`
  height: 0.3rem;
  width: 0;
  background: ${primaryColor};
  position: absolute;
  left: 60%;
  bottom: -80%;
  transform: translateX(-50%);

  &.active {
    @media (max-width: 768px) {
      width: 100% !important;
    }
  }

  @media (max-width: 768px) {
    left: 50%;
    bottom: -0.5rem;
  }

  @media (max-width: 480px) {
    bottom: -0.3rem;
  }
`;

export default Nav;
